import React from 'react';
import withNuiIntl from '../utils/withNuiIntl';
import compose from '../utils/compose';
import withStylesLoaded from '../utils/withStylesLoaded';
import Banner from './_Banner';

// this wrapper component is necessary to wrap the component
// in a ThemeProvider (handled in withStylesLoaded)
const AppBanner = (props) => <Banner {...props} />;

AppBanner.displayName = 'AppBanner';

AppBanner.propTypes = {
    ...Banner.propTypes,
};

export default compose(
    withStylesLoaded,
    withNuiIntl,
)(AppBanner);
